export default __webpack_public_path__ + "static/media/online-payment11.f970fa75.svg";